export const FULL_HEIGHT_PANEL_PORTAL_CLASSNAME =
  'filters-and-settings-full-height-portal';

export const ADD_BUTTON_CLASSNAME = 'filters-and-settings-add-button';
